<template>
  <div class="main">
    <main-header></main-header>
    <main-footer></main-footer>
  </div>
</template>

<script>
import MainFooter from './MainFooter.vue'
import MainHeader from './MainHeader'
export default {
  name:"MainCenter",
  components:{
    MainHeader,
    MainFooter
  }
}
</script>

<style lang="less">
.main{
  width: 100%;
  height: 97%;
  position: relative;
  &::before{
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 0;
    top: -5rem;
    background: url('../assets/image/背景1.png') no-repeat;
    background-size: 100% 100%;
  }
  &::after{
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: 0;
    z-index: 0;
    background: url("../assets/image/背景2.png") no-repeat;
    background-size: 100% 100%;
  }
}
</style>